/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */

import React, { useEffect, useMemo, useState } from 'react';
import { getLocale, useIntl } from 'umi';
import { Table, TableColumn } from 'tea-component';
import moment from 'moment';

import { formatPercentNum, formatNum, getIsErrorValue, getRatioText, commonValueFormatter } from '@/pages/dashboard/utils/utils';
import { getBreakDownHeader } from "@/pages/dashboard/pages/engagement/_config/utils";
import { headerText, percentMetricsList, unitMetricsList } from '../constant';
import Abnormal from '@/pages/dashboard/components/Abnormal';

import "@/pages/dashboard/assets/scss/page/Engagement/components/tableContext.scss";
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';
import { useSelectorMap } from '@/pages/dashboard/utils/customHook';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { renderCountryCell, renderValueCell, renderShareCell, TextWithOverflowBubble } from './renderUtils';
import { getCountryFlag } from '@home/_config/countries';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';
import SvgIcon from '@home/components/SvgIcon';

const { scrollable } = Table.addons;
const PUBLICHEIGHT = 397;

interface MiniTableColumn extends TableColumn {
  // 数据类型
  dataType: string;
  // 比率字段名
  ratioField?: string;
}


// render 配置
export const renderTableCols = (colsConfig: MiniTableColumn[], regionDataType: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getFilterItemText } = useSelectorMap();
  /**
	 * 数据处理
	 * @param value 当前字段的值
	 * @param record record
	 * @param dataType 字段类型
	 * @returns
	 */
  // @ts-ignore
  const handleData = (value, record, dataType) => {
    let ImgDom: JSX.Element;
    let systemImgDom: JSX.Element;
    const isOther = record.name === 'Others';
    try {
      ImgDom = <img src={getCountryFlag(record?.name)} alt="flag" className='register-table-country-img' />;
    } catch (error) {
      ImgDom = <img src={getCountryFlag('undefined')} alt="flag" />;
    }
    try {
      systemImgDom = record?.full_name?.toLowerCase()?.trim() === 'others' ? <></> :
        <img className='country-icon' src={getSystemFlag(record?.full_name)} alt="flag" />;
    } catch (error) {
      systemImgDom = <img className='country-icon' src={getSystemFlag('undefined')} alt="flag" />;
    }
    if (dataType && value) {
      // @ts-ignore
      return {
        // 保留整数
        integer: formatNum(value, false, true),
        // 保留两位小数
        twoDecimal: formatNum(value),
        // 百分比保留一位小数
        oneDecimalPercent: formatPercentNum(value, 1),
        // 百分比保留两位小数
        twoDecimalPercent: formatPercentNum(value, 2),
        // 月
        timeMonth: moment(value).format('YYYY-MM'),
        // 日、周
        time: moment(value).format('YYYY-MM-DD'),
        // 国家
        country: (
        // <div className="db-table__info">
        //   {value === 'Others' ? '' : createImg(value, 'db-table__info-pic')}
        //   <span className="db-table__info-txt">{record?.full_name || value || '-'}</span>
        // </div>
          <>
            {
              <div className='register-table-country'>
                {(regionDataType === 'country' && !isOther) && ImgDom}
                {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType === 'network_type' ? 'network' : regionDataType, record?.name, record?.full_name,)} /> : <div className='register-table-country-desc'>-</div>}
              </div>

            }
          </>
        ),
        region: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        zone: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        channel: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        os: (<>
          {
            <div className='register-table-country'>
              {(regionDataType === 'os' && !isOther) && systemImgDom}
              {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name)} /> : <div className='register-table-country-desc'>-</div>}
            </div>
          }
        </>),
        // 兜底system
        system: (<>
          {
            <div className='register-table-country'>
              {(regionDataType === 'os' && !isOther) && systemImgDom}
              {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record.name, record.full_name)} /> : <div className='register-table-country-desc'>-</div>}
            </div>
          }
        </>),
        lang: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        // 支持自定义维度（如 campaign 等）
        campaign: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        ua_network: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
        version: (
          <div className='register-table-country'>
            {(record?.name || record?.name !== null) ? <TextWithOverflowBubble text={getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-'} /> : <div className='register-table-country-desc'>-</div>}
          </div>
        ),
      }?.[dataType] || getFilterItemText(regionDataType, record?.name, record?.full_name) || value || '-';
    } if (value) {
      return value;
    }
    return '-';
  };

  return colsConfig?.map(({ render, dataType, decimalObj, ratioField, valueName, unit, isUserQuota = true, className = '', ...other }) => {
    return {
      ...other,
      render:
				render ||
				((record) => {
				  let textValue = handleData(record[other.key], record, dataType);
				  // 双列
				  if (ratioField) {
				    const { text, status } = getRatioText(record?.[ratioField], false);
				    let value = unit ? formatNum(record?.[valueName], true) : formatNum(record?.[valueName], false, isUserQuota);
				    // type: 'int',
				    // decimal: 0,
				    // percentDecimals: 0,
				    if (decimalObj) {
				      const { type, decimal, percentDecimals } = decimalObj;
				      value = commonValueFormatter(type, record?.[valueName], decimal);
				    }
				    textValue = (
				      // <MetricAndUpDown
				      //   metric={textValue}
				      //   updown={{ data: text, status }}
				      // />
				      <>
				        <div className={`register-table-daily ${className}`}>
				          <div className="register-table-daily-textsum">{value}</div>
				          <div className={
				            status === 'down' ?
				              'register-table-daily-red'
				              : status === '' || status === 'zero' ? 'register-table-daily-grey' : 'register-table-daily-green'}>{text}
				            {
				              status === '' ? '' : status === 'zero' ? <div className='register-table-daily-line' /> : <SvgIcon type={status === 'down' ? 'red-down-new' : 'green-up-new'} className='register-table-daily-icon' />
				            }
				          </div>

				        </div></>
				    );
				  }
				  return textValue;
				}),
    };
  });
};

const CountryTabBreakdown = (props: any) => {
  const {
    regionDataType,
    loading,
    data: propData,
    isSingle,
    isError,
    type,
    prefix,
    isHaveShare = true,
    isHaveDiscount = false,
    isUserQuota = false,
    unit = '',
    tableColumns,
    shareRename = '',
    isFooterFixed = true,
    setMapTooltipName,
    tabOption,
    extraColumn,
  } = props;
  const [columns, setColumns] = useState<any>([]);
  const { getFilterItemText } = useSelectorMap();
  const { countryName, valueName, share } = useMemo(() =>
    getBreakDownHeader(regionDataType, isSingle, type, prefix, shareRename)[regionDataType], [regionDataType, isSingle, type, prefix]);
  const { formatMessage } = useIntl();
  const isEn = getLocale() === 'en-US';

  const data = useMemo(() => {
    const newData = propData?.length >= 11 ? propData : propData?.filter((v: { name: string; value: string; }) => !(v?.name === 'Others' && v?.value === ''));
    return newData;
  }, [propData]);
  const isNodata = !data || data.length === 0;

  const handleColums = () => {
    const countryHead = headerText[countryName] ? formatMessage({ id: headerText[countryName] }) : countryName;
    const valueHead = headerText[valueName + unit] ? formatMessage({ id: headerText[valueName + unit] }, unitMetricsList?.includes(valueName + unit) ? { unit: getMonetUnit() } : {}) : valueName + unit;
    const baseColumns = [
      {
        key: 'country',
        header: countryHead,
        render: (t: any) => renderCountryCell({ record: t, regionDataType, getFilterItemText }),
      },
      {
        key: 'dau',
        header: valueHead,
        align: "right",
        render: (t: any) => renderValueCell({ record: t, isUserQuota, valueName, unit, percentMetricsList }),
      }
    ];
    if (isHaveShare && baseColumns.length) {
      const shareHead = headerText[share] ? formatMessage({ id: headerText[share] }) : share;
      baseColumns.push({
        key: 'share_of_all',
        align: "right",
        header: shareHead,
        render: (t: any) => renderShareCell({ record: t }),
      });
    }
    if (isHaveDiscount && baseColumns.length) {
      const discountHead = headerText[isSingle ? 'Discount' : 'Avg.Discount'] ? formatMessage({ id: headerText[isSingle ? 'Discount' : 'Avg.Discount'] }) : (isSingle ? 'Discount' : 'Avg.Discount');
      baseColumns.push({
        key: 'discount',
        align: "right",
        header: discountHead,
        render: (t: any) => {
          if (isHaveDiscount) {
            let discount: any = '-';
            if (getIsErrorValue(t?.discount)) {
              discount = '-';
            } else {
              discount = formatPercentNum(parseFloat(t.discount?.trim()), 1);
            }
            return (<span>{discount}</span>);
          } 
          return null;
          
        },
      });
    }
  
    // 自定义column
    extraColumn?.forEach((item) => {
      if (item.tabKey.includes(tabOption)) {
        const extraColumnHeader = isEn ? item.headerEN : item.headerCN;
        const formatRule = item?.dataFormats?.[tabOption] || item?.dataFormat;
        const mergeColumn = {
          key: item.columnKey,
          header: extraColumnHeader,
          align: "right",
          width: item.width,
          render: (t: any) => {
            let columnData: string | number = '-';
            if (getIsErrorValue(t?.[item.columnKey])) {
              columnData = '-';
            } else {
              columnData = dataFormat({ value: t?.[item.columnKey], formatRule });
            }
            return (<span>{columnData}</span>);
          },
        };
    
        // 自定义插入位置
        if (item.columnIndex !== undefined && item.columnIndex >= 0 && item.columnIndex <= baseColumns.length) {
          baseColumns.splice(item.columnIndex, 0, mergeColumn);
        } else {
          baseColumns.push(mergeColumn);
        }
      }
    });   
  
    setMapTooltipName(valueHead);
    setColumns(baseColumns);
  };

  useEffect(() => {
    !tableColumns && handleColums();
    tableColumns && setMapTooltipName && typeof tableColumns?.[1]?.header === 'string' && setMapTooltipName(tableColumns?.[1]?.header);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLocale(), countryName, valueName, share]);
  // 固定底部FooterFixed其他国家
  return (
    <>
      <Abnormal isLoading={loading} isError={isError} isNoData={isNodata}
        style={{ height: PUBLICHEIGHT, marginTop: '20px' }}
        component={
          <Table
            className={isFooterFixed ? "FooterFixed" : ''}
            records={data ? data : []}
            columns={tableColumns ? renderTableCols(tableColumns, regionDataType) : columns}
            addons={[
              scrollable({
                minHeight: PUBLICHEIGHT,
                maxHeight: PUBLICHEIGHT,
              })
            ]}
          />

        } />


    </>
  );
};

export default React.memo(CountryTabBreakdown);